import { number, bool, } from 'prop-types';
import { useForm, useField } from 'react-final-form';
import UploadingMultimedia from '../../UploadingMultimedia';
import UploadingDrone from '../../UploadingDrone';
import NavigationButtons from '../NavigationButtons';
import { TitleWrapper } from '../common';
import { MULTIMEDIA_TYPES, DRONE_TYPES } from '../../../../config';

const getTypeStr = type => {
  switch(type) {
    case 'single':
      return 'Single photo';
    case 'panorama':
      return 'Panorama';
    case 'video':
      return 'Video';
    case 'forest':
      return 'Forest inventory';
    case 'mill':
      return 'Mill inventory';
    default:
      return '-';
  }
}

function UploadInformation({
  currentStep,
  hasValidationErrors
}) {
  const { change } = useForm();
  const {
    input: { value: selectedType },
  } = useField(`uploadType`, {
    subscription: { value: true },
  });

  return (
    <>
      <TitleWrapper>
        <p>Selected media type - <span>{getTypeStr(selectedType)}</span></p>
        <p>
          Please provide basic information about the media to be uploaded.
        </p>
      </TitleWrapper>
      {
        MULTIMEDIA_TYPES.includes(selectedType) &&
        <UploadingMultimedia uploadType={selectedType}></UploadingMultimedia>
      }
      {
          DRONE_TYPES.includes(selectedType) &&
        <UploadingDrone uploadType={selectedType}></UploadingDrone>
      }
       <NavigationButtons
        currentStep={currentStep}
        isNextDisabled={hasValidationErrors}
        onBackClick={() => change('currentStep', currentStep - 1)}
        onNextClick={() => change('currentStep', currentStep + 1)} />
    </>
  );
}

UploadInformation.propTypes = {
  currentStep: number.isRequired,
  hasValidationErrors: bool.isRequired,
}

export default UploadInformation;